export const BOT_LINK = import.meta.env.VITE_BOT_LINK || 'https://t.me/haydovchiappbot';

export const BOT_PHONE_LINK = `${BOT_LINK}?start=phone`;

export const BOT_LOGIN_LINK = `${BOT_LINK}?start=applogin`;

export function privacyLink(configured: string | undefined, base: string): string | null {
  const path = (configured ?? '/privacy.html').trim();
  return path ? new URL(path, base).href : null;
}

export const PRIVACY_URL = privacyLink(
  import.meta.env.VITE_PRIVACY_URL,
  import.meta.env.VITE_API_BASE_URL || window.location.origin,
);

export const PLAY_STORE_URL = import.meta.env.VITE_PLAY_STORE_URL?.trim() || null;
